var map = {
	"./20230213_122108-min.jpg": 5467,
	"./20230213_122108.jpg": 996,
	"./20230214_122259.jpg": 2924,
	"./20231602.jpeg": 5877,
	"./Ady.jpeg": 8331,
	"./Ady.png": 3450,
	"./Carlo.jpeg": 5844,
	"./Carlo.jpg": 4923,
	"./Cristina.jpeg": 6342,
	"./Cristina.jpg": 33,
	"./Cristina.png": 5753,
	"./DSC_0592.JPG": 5316,
	"./DSC_0605.JPG": 4707,
	"./DSC_0607.JPG": 5697,
	"./DSC_0608.JPG": 4730,
	"./DSC_0610.JPG": 3737,
	"./DSC_0613.JPG": 3134,
	"./DSC_0618.JPG": 5521,
	"./DSC_0619.JPG": 6324,
	"./DSC_0619.jpeg": 6030,
	"./DSC_0620.jpeg": 2650,
	"./DSC_0620.jpg": 7477,
	"./DSC_0621.jpeg": 8545,
	"./DSC_0621.jpg": 3512,
	"./DSC_0622.jpeg": 1440,
	"./DSC_0623.jpeg": 6007,
	"./DSC_0624.jpeg": 9950,
	"./DSC_0625.jpeg": 4581,
	"./DSC_0626.JPG": 8350,
	"./DSC_0636.JPG": 7785,
	"./DSC_0638.JPG": 3359,
	"./DSC_0639.JPG": 514,
	"./DSC_0640.JPG": 6574,
	"./DSC_0645.JPG": 6903,
	"./DSC_0649.JPG": 7971,
	"./DSC_0658.JPG": 1629,
	"./DSC_0667.JPG": 3087,
	"./DSC_0671.JPG": 726,
	"./DSC_0673.JPG": 4404,
	"./DSC_0675.JPG": 4914,
	"./DSC_0680.JPG": 8906,
	"./DSC_0690.JPG": 657,
	"./DSC_0702.JPG": 277,
	"./DSC_0703.jpeg": 7150,
	"./DSC_0703.jpg": 8873,
	"./DSC_0713.JPG": 9415,
	"./DSC_0714.jpeg": 4334,
	"./DSC_0715.jpeg": 6821,
	"./DSC_0716.jpeg": 884,
	"./DSC_0716.jpg": 5755,
	"./DSC_0717.jpeg": 2043,
	"./Damian.png": 4766,
	"./Dra. Adela.png": 1670,
	"./Emilio.jpeg": 5098,
	"./Emilio.png": 1349,
	"./Eva.jpeg": 5149,
	"./Fabiola.jpeg": 6409,
	"./Fabiola.png": 1396,
	"./Fernanda.jpg": 519,
	"./Fernanda.png": 8343,
	"./Francisco Javier.png": 3979,
	"./Ingrid.jpeg": 4998,
	"./Ingrid.png": 166,
	"./Javier.jpeg": 1382,
	"./Johana.png": 6103,
	"./Jonathan.jpeg": 3256,
	"./Jonathan.png": 9151,
	"./Jorge Alexis.jpeg": 336,
	"./Jorge Alexis.png": 5879,
	"./Jose Julian.png": 3342,
	"./Juan Pablo.jpeg": 9773,
	"./Juan Pablo.png": 480,
	"./Julie.jpeg": 1974,
	"./Julie.jpg": 4625,
	"./Lorena.jpeg": 7500,
	"./Monse.jpg": 1956,
	"./Monse.png": 8992,
	"./Patricio.jpg": 1919,
	"./Patricio.png": 5967,
	"./Paula.jpeg": 1430,
	"./Roxana.JPG": 7446,
	"./Roxana.png": 4389,
	"./Selene.png": 2954,
	"./Seminario II.jpeg": 9514,
	"./Uriel.jpeg": 1288,
	"./Uriel.png": 3391,
	"./Vicente Arturo.jpeg": 4036,
	"./Vicente Arturo.png": 1651,
	"./Yuridia.png": 2535,
	"./ana.jpg": 5856,
	"./ana.png": 5012,
	"./braddaichi.jpg": 5075,
	"./cesaralan.jpg": 7022,
	"./d3e7c18e-444c-48cc-8fa3-9600e1f039ee.jpeg": 1581,
	"./eventos/CIIDIT.jpg": 8790,
	"./eventos/Electromobility.webp": 6918,
	"./eventos/Energy.png": 1981,
	"./eventos/Incubadora.jpg": 3695,
	"./eventos/LTH.jpg": 4249,
	"./eventos/nanotec.png": 8623,
	"./eventos/nanotecnologia.jpg": 256,
	"./eventos/python.jpg": 5239,
	"./eventos/seminario.gif": 6863,
	"./jessica.jpg": 916,
	"./jessica.png": 7952,
	"./joshua.jpg": 6878,
	"./rafa.jpg": 304,
	"./rafa.png": 1108,
	"./raphael.jpg": 9489,
	"./sergio.jpg": 3185,
	"./sergio.png": 7433,
	"./unknown.png": 3920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7822;